import React from 'react';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import closedPage from '@assets/closed-page.png';
import { useStyles, useStylesButton } from './styles';

const ClosedPage = () => {
  const { t } = useTranslation('closedPage');
  const classes = useStyles();
  const classesButton = useStylesButton();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <img src={closedPage} alt="closed-page" />
        <div className={classes.textPart}>
          <p className={classes.title}>{t('title')}</p>
          <p className={classes.subTitle}>{t('subTitle')}</p>
        </div>
      </div>
      <PrimaryButton
        text={t('openCameraButton')}
        classesButton={classesButton}
        handleClick={() => {}}
      />
    </div>
  );
};

export default ClosedPage;
